module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_kornbluth_sm-8842d86ee7784c31875c65c696035140.png";